module.exports = __webpack_public_path__ + "img/_ionicons_svg_ios-arrow-back.74bf46eb.svg";